<template>
  <div>
    <SharedTopNotification />
    <SharedHeader />
    <div
      class="px-20 py-20 flex items-center justify-center bg-background text-white"
    >
      <div class="max-w-md mx-auto text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="w-12 h-12 mx-auto mb-4 text-primary"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
          ></path>
        </svg>
        <h1 class="text-4xl font-bold text-primary">
          Sorry, something went wrong.
        </h1>
        <p class="text-lg text-font-primary">
          The page may have been removed or be temporarily unavailable. Also
          check that the web address has been typed correctly.
        </p>
        <div class="mt-6">
          <a
            href="/"
            class="px-4 py-2 border border-primary text-primary rounded-md hover:bg-primary hover:text-white"
            >Go Home</a
          >
        </div>
      </div>
    </div>
    <SharedFooter />
    <NavigationMobileBottom class="md:hidden" />
  </div>
</template>

<script setup>
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
});

// Log error details when component is mounted
onMounted(() => {
  const errorDetails = {
    statusCode: props.error?.statusCode,
    message: props.error?.message,
    stack: props.error?.stack,
    data: props.error?.data,
    url: window?.location?.href,
    error: props.error,
    componentStack: props.error?.errorInfo?.componentStack,
    info: props.error?.info,
    errorLocation: props.error?.errorLocation,
    component: props.error?.component,
    fullError: JSON.stringify(props.error, null, 2),
  };

  console.error("Detailed Error Information:");
  console.error(JSON.stringify(errorDetails, null, 2));

  // Add visual error details in development
  // if (process.dev) {
  //   const errorDiv = document.createElement('div');
  //   errorDiv.style.position = 'fixed';
  //   errorDiv.style.bottom = '20px';
  //   errorDiv.style.right = '20px';
  //   errorDiv.style.maxWidth = '80%';
  //   errorDiv.style.maxHeight = '50%';
  //   errorDiv.style.overflow = 'auto';
  //   errorDiv.style.background = '#fff';
  //   errorDiv.style.padding = '20px';
  //   errorDiv.style.border = '1px solid #ccc';
  //   errorDiv.style.borderRadius = '4px';
  //   errorDiv.style.zIndex = '9999';
  //   errorDiv.style.whiteSpace = 'pre-wrap';
  //   errorDiv.innerHTML = `<h3>Error Details:</h3><pre>${JSON.stringify(errorDetails, null, 2)}</pre>`;
  //   document.body.appendChild(errorDiv);
  // }
});
</script>
